import dayjs from 'dayjs'
import { ProfileSuspension } from '../types'

/**
 * Sorts items by date in descending order (most recent first).
 */
export const sortByDate = <T extends Record<string, any>>(
  items: T[] = [],
  dateField = 'end_date'
): T[] => {
  return [...items].sort((itemA, itemB) => {
    const dateA = dayjs(itemA[dateField])
    const dateB = dayjs(itemB[dateField])

    if (dateA.isAfter(dateB)) {
      return -1
    }

    if (dateA.isBefore(dateB)) {
      return 1
    }

    return 0
  })
}

/**
 * Formats the active suspension alert text.
 */
export const getSuspensionStatusText = (
  suspension: ProfileSuspension
): string => {
  if (suspension?.end_date) {
    return `You're Suspended Until ${dayjs(suspension.end_date)
      .utc()
      .format('MMM D, YYYY')} (${suspension.description})`
  }

  return `You're Suspended Indefinitely (${suspension.description})`
}
